import Vue from 'vue'

export default {
  ADD_WEBINARS (state, webinars) {
    state.webinars = webinars
  },
  ADD_NEW_WEBINAR (state, webinar) {
    state.webinars.unshift(webinar)
  },
  UPDATE_WEBINAR (state, webinar) {
    Object.assign(state.webinars.find(w => w.id === webinar.id), webinar)
  },
  ADD_SPEAKERS (state, speakers) {
    state.speakers = speakers
  },
  DELETE_WEBINAR (state, id) {
    state.webinars = state.webinars.filter(w => w.id !== id)
  },
  ADD_WEBINAR_SPEAKER (state, speaker) {
    state.speakers.push(speaker)
  },
  DELETE_WEBINAR_SPEAKER (state, id) {
    state.speakers = state.speakers.filter(s => s.id !== id)
  },
  CHANGE_WEBINAR_SPEAKER_PHOTO (state, photoData) {
    let s = state.speakers.find(c => c.id === photoData.speakerId)
    Vue.set(s, 'photo', photoData)
  },
  DELETE_WEBINAR_SPEAKER_PHOTO (state, id) {
    let s = state.speakers.find(c => c.id === id)
    Vue.set(s, 'photo', '')
  },
  ADD_WEBINAR_REVIEWS (state, webinars) {
    state.webinarsReviews = webinars
  },
  DELETE_WEBINAR_REVIEW (state, id) {
    state.webinarsReviews = state.webinarsReviews.filter(w => w.id !== id)
  },
  PUBLISH_WEBINAR_REVIEW (state, id) {
    const review = state.webinarsReviews.find(w => w.id === id)
    review.isPublished = true
  },
  UPDATE_WEBINAR_SPEAKER (state, speaker) {
    let s = state.speakers.find(c => c.id === speaker.id)
    Object.assign(s, speaker)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/webinars.js